import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';
import { AircraftType } from '@ogn-tracker/common/build/enum/aircraft-type';

type AircraftEnumTypeKeys = {[key in AircraftType]: boolean;}

export interface VehiclesState extends AircraftEnumTypeKeys {
  self: boolean;
}

export function createInitialState(): VehiclesState {
  return {
    self: true,
    [AircraftType._RESERVED_]: true,
    [AircraftType.GLIDER]: true,
    [AircraftType.TOW_PLANE]: true,
    [AircraftType.HELICOPTER]: true,
    [AircraftType.PARACHUTE]: true,
    [AircraftType.DROP_PLANE]: true,
    [AircraftType.HANG_GLIDER]: true,
    [AircraftType.PARAGLIDER]: true,
    [AircraftType.AIRCRAFT_REC]: true,
    [AircraftType.AIRCRAFT_JET]: true,
    [AircraftType.UNKNOWN]: true,
    [AircraftType.BALLON]: true,
    [AircraftType.AIRSHIP]: true,
    [AircraftType.UAV]: true,
    [AircraftType._RESERVED2_]: true,
    [AircraftType.STATIC_OBSTACLE]: true,
  };
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'vehicles', resettable: true })
export class VehiclesStore extends Store<VehiclesState> {
  constructor() {
    super(createInitialState());
  }
}
